<template>
  <span>
    <span :class="['right-tab',initNum==index&&finalSequence[0] == 'left'?'curr':'']"
          v-show="item.name||item.selectCircleName || item.trueName">
      <span @click="tabSwitch($event,item)"
            @contextmenu.stop.prevent="tabRight(item,$event)"
            @touchstart.stop="touchstarts(item,$event)"
            @touchmove="touchmoves"
            @touchend="touchends">
        <span :class="['text',{'Icon':item.acquiesceType}]">
          <span class="photo">
            <ZImage v-if="item.selectCircleIcon || item.selectCircleIcon==='' || item.photo"
                    :value="item.selectCircleIcon?item.selectCircleIcon:''"
                    :error-src="require('../../../assets/image/images/icon_defalut.png')" />
          </span>
          
          {{item.name?item.name:(item.selectCircleName?item.selectCircleName:item.trueName)}}
          <!-- <span v-show="$route.name=='Next'"
                  v-if="item.tabType=='check'"
                  class="first">u</span> -->
        </span>
      </span>
    </span>
    <leftMenu :item="sub"
              v-for="(sub,ind) in tabNav"
              :key="ind"
              :blockData="blockData"></leftMenu>
  </span>
</template>

<script>
// import $ from 'jquery'
export default {
  name: "leftMenu",
  props: {
    item: Object,
    blockData: Object,
    index: Number,
    finalSequence: Array,
  },
  data () {
    return {
      tabNav: [],
      twids: 0,
      initNum: 0
    }
  },
  //跨级触发方法
  inject: ["fatherMethod", "updateHeight", "tabRight"],
  methods: {
    touchstarts (item, ev) {
      var _this = this;
      // 长按事件触发
      clearTimeout(_this.timeOutEvent);
      _this.timeOutEvent = setTimeout(function () {
        _this.timeOutEvent = 0;
        _this.tabRight(item, ev);
      }, 400);
      //长按400毫秒
      // e.preventDefault();
    },
    touchmoves () {
      clearTimeout(this.timeOutEvent);
      this.timeOutEvent = 0;
    },
    touchends () {
      clearTimeout(this.timeOutEvent);
      if (this.timeOutEvent != 0) {
        // 点击事件    
        // this.rightShow = false;
      }
      return false;
    },
    tabSwitch (ev, n) {
      $(ev.target).parents('.outreach_content').find('.right-tab').removeClass('curr');
      $(ev.target).parents('.right-tab').addClass('curr');
      //触发父级点击事件
      this.fatherMethod(n);
      if (n.flowType == 'flow') {
        if (this.tabNav.length) {
          //如果下级有长度，就置空，并且减去长度
          this.updateHeight(-this.twids);
          this.tabNav = [];
        } else {
          // if(this.blockData.flowEnName == 'meta-universe'){
          this.getFlowOrBlockByFlowId(n, ev);
          // }
        }
      }
    },
    getFlowOrBlockByFlowId (item, ev) {

      var url='/zciid-deliverable/showPlatformStyle/flow/api/get/getFlowFloorDataSpit.json',
      data = {
          appId: this.$appId,
          flowId: item.id,
          diyPageFlowId: '',
          domainNameType: document.location.pathname.split('/')[1],
          isBlock: item.orgType != '-1' ? 'newType' : 'yes',
          userId: this.$store.state.userInfo.userId,
          acquiesceType:item.acquiesceType ? item.acquiesceType: '',
          floorEnName:this.blockData.flowEnName
        };
      var arrays=['OrgBizCircle','SpecialPlatform','GovernmentOrgBizCircle','EnterprisesOrgBizCircle','SpecialOrgBizCircle','CustomOrgBizCircle','IntelligentMan','SpecialSocialPlatform','SpecialServicePlatform','SpecialEquipmentPlatform','SpecialMailboxPlatform'];
      if(item.enName != 'IntelligentMan'&& arrays.indexOf(item.enName) > -1){
        url = '/zciid-deliverable/showPlatformStyle/flow/api/getBlockIdByFlowId.json';
        data.floorEnName = this.blockData.flowEnName;
      }
      this.$http
        .get(url, data).then(res => {
          var datas;
          if(item.enName == 'OrgBizCircle'){
            datas = res.data[0].dataArr.splice(0,2);
          }else{
            datas = res.data[0].dataArr.splice(0,3);
          }
          this.tabNav = datas;
          //计算新增宽度并传给父级
          this.twids = datas.length * 61;
          this.updateHeight(this.twids);
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.right-tab {
  position: relative;
  border-bottom: 1px solid #ddd;
  cursor: pointer;
  display: block;
  height: 60px;
  line-height: 61px;
  padding-left: 8px;
  font-size: 16px;
}
.text.Icon{
  background: url('../../../assets/image/images/icons/sub_icon_menu_black.png') no-repeat 1px center;
}
.right-tab.curr .Icon{
  background: url('../../../assets/image/images/icons/sub_icon_menu_blue.png') no-repeat 1px center;
}
.photo {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  vertical-align: middle;
  margin-top: -2px;
  // padding-right: 5px;
  display: inline-flex;
}
.photo > .Img{
  width: 15px;
  height: 15px;
  margin: 2px;
}
.photo > .z-image .el-image__inner {
  width: 20px;
  height: 20px;
  border-radius: 50%;
}
.right-tab.curr {
  position: relative;
  border-left: 1px solid #0d78cf;
  color: #0d78cf;
}
.text {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
}
@media screen   and (max-width: 768px) {
  .content-left-box {
    position: absolute;
    background: #fff;
    z-index: 9;
    border: 1px solid #dddddd;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/floorBlock/control/leftMenu.vue